<ng-template #voorwaarden>
    <!-- prettier-ignore -->
    <p>Bovenstaande is een samenvatting van onze dekking. Hoe u precies bent verzekerd staat
        <ins-pdf-link [pdfLink]="documentsEnum.ConditionsMopedInsurance" pdfLinkTitle="Voorwaarden Autoverzekering">in
            onze voorwaarden</ins-pdf-link>.
    </p>
</ng-template>

<wuc-tabset tabsetStyle="secondary" *ngIf="coverageId === coverageIdEnum.BromWA">
    <wuc-tabset-item name="Wel verzekerd">
        <wuc-rack gridGap="medium">
            <div>
                <p>Schade die u of een andere bestuurder veroorzaakt aan anderen:</p>
                <wuc-list icon="dot">
                    <wuc-list-item>Met uw brommer</wuc-list-item>
                    <wuc-list-item>In het verkeer met een aanhangwagen die aan uw brommer is gekoppeld
                    </wuc-list-item>
                    <wuc-list-item>Door lading die van uw brommer afvalt</wuc-list-item>
                </wuc-list>
            </div>
            <ng-container *ngTemplateOutlet="voorwaarden"></ng-container>
        </wuc-rack>
    </wuc-tabset-item>
    <wuc-tabset-item name="Niet verzekerd">
        <wuc-rack gridGap="medium">
            <div>
                <wuc-list icon="dot">
                    <wuc-list-item>Schade aan uw eigen brommer</wuc-list-item>
                    <wuc-list-item>Schade aan de bestuurder van uw brommer</wuc-list-item>
                    <wuc-list-item>Schade aan de lading en bagage die met de brommer vervoerd werd</wuc-list-item>
                </wuc-list>
            </div>
            <div>
                <p>En niet verzekerd is:</p>
                <wuc-list icon="dot">
                    <wuc-list-item>
                        Schade door zakelijk gebruik, verhuur of lease van uw brommer aan een ander
                    </wuc-list-item>
                    <wuc-list-item>
                        Als het kenteken niet op uw naam of naam van uw partner (zelfde adres) staat
                    </wuc-list-item>
                    <wuc-list-item>Schade als uw brommer wordt gebruikt bij een wedstrijd</wuc-list-item>
                </wuc-list>
            </div>
            <div>
                <p>Soms is schade niet verzekerd. Maar verplicht de wet ons dat wij de schade aan een ander wel
                    moeten betalen. U moet de schade aan ons terugbetalen. Dit geldt als:</p>
                <wuc-list icon="dot">
                    <wuc-list-item>U meer alcohol had gedronken dat wettelijk is toegestaan</wuc-list-item>
                    <wuc-list-item>
                        Als u geen geldig rijbewijs had of de schade met opzet heeft veroorzaakt
                    </wuc-list-item>
                    <wuc-list-item>Als iemand uw brommer gebruikte zonder uw toestemming</wuc-list-item>
                </wuc-list>
            </div>
            <ng-container *ngTemplateOutlet="voorwaarden"></ng-container>
        </wuc-rack>
    </wuc-tabset-item>
    <wuc-tabset-item name="Verzekerde bedragen">
        <wuc-rack gridGap="medium">
            <wuc-list icon="dot">
                <wuc-list-item>€&nbsp;6.500.000 voor schade aan andere personen</wuc-list-item>
                <wuc-list-item>€&nbsp;2.500.000 voor schade aan spullen van andere personen</wuc-list-item>
            </wuc-list>
            <ng-container *ngTemplateOutlet="voorwaarden"></ng-container>
        </wuc-rack>
    </wuc-tabset-item>
    <wuc-tabset-item name="Eigen Risico">
        <p class="no-brake">€&nbsp;0</p>
        <p>Rijdt er iemand anders op de brommer dan de regelmatige bestuurder? Dan geldt er per schade een
            eigen risico van €&nbsp;400 als de andere bestuurder jonger is dan 25 jaar en jonger is dan de regelmatige
            bestuurder die is opgegeven.</p>
        <ng-container *ngTemplateOutlet="voorwaarden"></ng-container>
    </wuc-tabset-item>
</wuc-tabset>

<wuc-tabset tabsetStyle="secondary" *ngIf="coverageId === coverageIdEnum.BromBeperktCasco">
    <wuc-tabset-item name="Wel verzekerd">
        <wuc-rack gridGap="medium">
            <div>
                <p>Schade aan uw brommer door:</p>
                <wuc-list icon="dot">
                    <wuc-list-item>
                        Diefstal. U bent verzekerd als uw brommer met een ART categorie 3-slot afgesloten is
                    </wuc-list-item>
                    <wuc-list-item>Storm</wuc-list-item>
                    <wuc-list-item>Hagel</wuc-list-item>
                    <wuc-list-item>Brand</wuc-list-item>
                    <wuc-list-item>Aanrijding met dieren</wuc-list-item>
                </wuc-list>
            </div>
            <ng-container *ngTemplateOutlet="voorwaarden"></ng-container>
        </wuc-rack>
    </wuc-tabset-item>
    <wuc-tabset-item name="Niet verzekerd">
        <wuc-rack gridGap="medium">
            <div>
                <p>Schade aan uw brommer door:</p>
                <wuc-list icon="dot">
                    <wuc-list-item>Bevriezing, lekkage en inwerking van vocht</wuc-list-item>
                    <wuc-list-item>Normale gebruiksschade zoals krassen, kleine putjes en schrammen</wuc-list-item>
                    <wuc-list-item>Slijtage</wuc-list-item>
                    <wuc-list-item>Slecht onderhoud</wuc-list-item>
                    <wuc-list-item>Onderdelen die kapot gegaan zijn zonder dat er een ongeluk geweest is</wuc-list-item>
                    <wuc-list-item>Constructie- en materiaalfouten</wuc-list-item>
                    <wuc-list-item>Doordat u niet zorgvuldig met de brommer of brommersleutels omgegaan bent. Denk aan:
                        sleutels in de brommer gelaten of brommer niet op slot
                    </wuc-list-item>
                </wuc-list>
            </div>
            <ng-container *ngTemplateOutlet="voorwaarden"></ng-container>
        </wuc-rack>
    </wuc-tabset-item>
    <wuc-tabset-item name="Verzekerde bedragen">
        <wuc-rack gridGap="medium">
            <wuc-list icon="dot">
                <wuc-list-item>Bij schade aan uw brommer maximaal de reparatiekosten</wuc-list-item>
                <wuc-list-item>
                    Bij diefstal of totaal verlies van uw brommer maximaal:
                    <wuc-list icon="dot">
                        <wuc-list-item>
                            Nieuwwaarde als de brommer jonger dan 1 jaar is en u de 1e eigenaar bent
                        </wuc-list-item>
                        <wuc-list-item>
                            Aanschafwaarde van uw brommer. Maar alleen als u de brommer korter dan 1 jaar
                            geleden tweedehands gekocht heeft bij een bedrijf dat volgens het register van
                            de Kamer van Koophandel handelt in fietsen en bromfietsen
                        </wuc-list-item>
                        <wuc-list-item>Dagwaarde (maximaal verschil waarde voor en na schade)</wuc-list-item>
                    </wuc-list>
                </wuc-list-item>
                <wuc-list-item>Accessoires tot €&nbsp;350</wuc-list-item>
                <wuc-list-item>Brommerhelm tot €&nbsp;200</wuc-list-item>
                <wuc-list-item>Vervangend vervoer tot €&nbsp;40</wuc-list-item>
            </wuc-list>
            <p>
                De Beperkt Casco dekking sluit u aanvullend op de WA. Voor schade aan anderen gelden de
                regels van de WA verzekering.
            </p>
            <ng-container *ngTemplateOutlet="voorwaarden"></ng-container>
        </wuc-rack>
    </wuc-tabset-item>
    <wuc-tabset-item name="Eigen Risico">
        <wuc-rack gridGap="medium">
            <wuc-list icon="dot">
                <wuc-list-item>
                    Voor schade aan de brommer geldt er een standaard eigen risico van €&nbsp;200 per gebeurtenis
                </wuc-list-item>
                <wuc-list-item>
                    Er geldt een eigen risico van €&nbsp;400 bij diefstal als de brommer niet is vast gezet aan een
                    in de grond verankerd voorwerp met een ART categorie 3-slot
                </wuc-list-item>
                <wuc-list-item>
                    Rijdt er iemand anders op de brommer dan de regelmatige bestuurder? Dan geldt er per schade een
                    eigen risico van €&nbsp;400 als de andere bestuurder jonger is dan 25 jaar en jonger is dan de
                    regelmatige bestuurder die is opgegeven
                </wuc-list-item>
            </wuc-list>
            <ng-container *ngTemplateOutlet="voorwaarden"></ng-container>
        </wuc-rack>
    </wuc-tabset-item>
</wuc-tabset>

<wuc-tabset tabsetStyle="secondary" *ngIf="coverageId === coverageIdEnum.BromAllrisk">
    <wuc-tabset-item name="Wel verzekerd">
        <wuc-rack gridGap="medium">

            <div>
                <p>Schade aan uw eigen brommer door:</p>
                <wuc-list icon="dot">
                    <wuc-list-item>(Poging tot) diefstal en joyriding</wuc-list-item>
                    <wuc-list-item>Brand, kortsluiting en ontploffing</wuc-list-item>
                    <wuc-list-item>Storm, blikseminslag, hagel en overstroming</wuc-list-item>
                    <wuc-list-item>Botsing met dieren</wuc-list-item>
                    <wuc-list-item>Aanrijding, parkeren en eigen schuld (per ongeluk)</wuc-list-item>
                </wuc-list>
            </div>
            <div>
                <p>Schade die u of een andere bestuurder veroorzaakt aan anderen:</p>
                <wuc-list icon="dot">
                    <wuc-list-item>Met uw brommer</wuc-list-item>
                    <wuc-list-item>In het verkeer met een aanhangwagen die aan uw brommer is gekoppeld</wuc-list-item>
                    <wuc-list-item>Door lading die van uw brommer afvalt</wuc-list-item>
                </wuc-list>
            </div>
            <div>
                <p>De Allrisk sluit u aanvullend op de WA. Voor schade aan anderen gelden de regels van de WA
                    verzekering.</p>
            </div>
            <ng-container *ngTemplateOutlet="voorwaarden"></ng-container>
        </wuc-rack>
    </wuc-tabset-item>
    <wuc-tabset-item name="Niet verzekerd">
        <wuc-rack gridGap="medium">
            <div>
                <wuc-list icon="dot">
                    <wuc-list-item>
                        Schade door diefstal als u niet voldoet aan de beveiligingseisen. Bij stalling buitenshuis
                        moet de brommer met een ART-Categorie 3 (of hoger) ketting- of beugelslot worden bevestigd
                        aan de “vaste” wereld (bijvoorbeeld een lantaarnpaal, verankerd fietsenrek of hek of boom)
                    </wuc-list-item>
                    <wuc-list-item>Schade door slijtage of slecht onderhoud</wuc-list-item>
                    <wuc-list-item>Verkleuringen, krassen of andere lakschade</wuc-list-item>
                    <wuc-list-item>Schade door bevriezing</wuc-list-item>
                    <wuc-list-item>
                        Schade door fouten of wijzigingen in de constructie, het frame of de motor van de brommer
                    </wuc-list-item>
                    <wuc-list-item>Schade uitsluitend aan banden</wuc-list-item>
                    <wuc-list-item>Schade door tanken van verkeerde brandstof</wuc-list-item>
                    <wuc-list-item>
                        Schade als uw brommer is opgevoerd of als er technische wijzigingen zijn aangebracht
                    </wuc-list-item>
                </wuc-list>
            </div>
            <div>
                <p>En niet verzekerd is schade:</p>
                <wuc-list icon="dot">
                    <wuc-list-item>Door opzet of bij rijden zonder rijbewijs</wuc-list-item>
                    <wuc-list-item>Als u alcohol of drugs heeft gebruikt</wuc-list-item>
                    <wuc-list-item>Door zakelijk gebruik, verhuur of lease van uw brommer aan een ander</wuc-list-item>
                    <wuc-list-item>
                        Als het kenteken niet op uw naam of naam van uw partner (zelfde adres) staat
                    </wuc-list-item>
                </wuc-list>
            </div>
            <div>
                <p>
                    De Allrisk sluit u aanvullend op de WA. Voor schade aan anderen gelden de regels van de WA
                    verzekering.
                </p>
            </div>
            <ng-container *ngTemplateOutlet="voorwaarden"></ng-container>
        </wuc-rack>
    </wuc-tabset-item>
    <wuc-tabset-item name="Verzekerde bedragen">
        <wuc-rack gridGap="medium">
            <wuc-list icon="dot">
                <wuc-list-item>Bij schade aan uw brommer maximaal de reparatiekosten</wuc-list-item>
                <wuc-list-item>
                    Bij diefstal of totaal verlies van uw brommer maximaal:
                    <wuc-list icon="dot">
                        <wuc-list-item>
                            Nieuwwaarde als de brommer jonger dan 1 jaar is en u de 1e eigenaar bent
                        </wuc-list-item>
                        <wuc-list-item>
                            Aanschafwaarde van uw brommer. Maar alleen als de brommer jonger is dan 10 jaar en u de
                            brommer korter dan 1 jaar geleden tweedehands gekocht heeft bij een bedrijf dat volgens
                            het register van de Kamer van Koophandel handelt in fietsen en bromfietsen
                        </wuc-list-item>
                        <wuc-list-item>Dagwaarde (maximaal verschil waarde voor en na schade)</wuc-list-item>
                    </wuc-list>
                </wuc-list-item>
                <wuc-list-item>Accessoires tot €&nbsp;350</wuc-list-item>
                <wuc-list-item>Brommerhelm tot €&nbsp;200</wuc-list-item>
                <wuc-list-item>Vervangend vervoer tot €&nbsp;40</wuc-list-item>
            </wuc-list>
            <p>
                De Allrisk sluit u aanvullend op de WA. Voor schade aan anderen gelden de regels van de WA verzekering.
            </p>
            <ng-container *ngTemplateOutlet="voorwaarden"></ng-container>
        </wuc-rack>
    </wuc-tabset-item>
    <wuc-tabset-item name="Eigen Risico">
        <wuc-rack gridGap="medium">
            <wuc-list icon="dot">
                <wuc-list-item>€&nbsp;200 bij schade veroorzaakt door de regelmatige bestuurder</wuc-list-item>
                <wuc-list-item>
                    €&nbsp;400, als:
                    <wuc-list icon="dot">
                        <wuc-list-item>Iemand anders op de brommer rijdt dan de regelmatige bestuurder. En de andere
                            bestuurder jonger is dan 25 jaar en jonger is dan de regelmatige bestuurder die is opgegeven
                        </wuc-list-item>
                        <wuc-list-item>Uw brommer gestolen of vermist is en niet met een ART categorie 3-slot was
                            vastgemaakt aan een in de grond verankerd voorwerp. Bijvoorbeeld een lantaarnpaal, verankerd
                            fietsenrek of hek of boom
                        </wuc-list-item>
                    </wuc-list>
                </wuc-list-item>
            </wuc-list>
            <ng-container *ngTemplateOutlet="voorwaarden"></ng-container>
        </wuc-rack>
    </wuc-tabset-item>
</wuc-tabset>
